export * from './dashboard-item/dashboard-item-agenda/dashboard-item-agenda.component';
export * from './dashboard-item/dashboard-item-elearning/dashboard-item-elearning.component';
export * from './dashboard-item/dashboard-item-graphique/dashboard-item-graphique.component';
export * from './dashboard-item/dashboard-item-grid/dashboard-item-grid.component';
//export * from './dashboard-item/dashboard-item-list/dashboard-item-list.component';
export * from './dashboard-item/dashboard-item-message/dashboard-item-message.component';
export * from './dashboard.component';
export * from './dashboard.module';
export * from './dashboard.pipe';
export * from './dashboard.service';
